import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { TamariskAppraisalStore } from '../store/tamariskAppraisalStore';

export const useTamariskAppraisalStore = () =>
  useContext<{
    tamariskAppraisalStore: TamariskAppraisalStore;
  }>(StoreContext);
